<template>
    <div class="uk-text-center design-tool-width-modal">
        <div class="design-tool-width-modal-content">
            <div class="uk-h4">A Wider Screen or Window is Required</div>

            <p>
                <BaseIcon height="110" stroke="#AAC438" stroke-width="0.4" width="110">
                    <IconViewportWide />
                </BaseIcon>
            </p>

            <p>Our design tools have been optimized for wider screens. You may wish to enlarge your window to the full
                width of your screen or revisit this page on a device which has a wider screen.
            </p>
            <p>
                <button class="uk-button uk-button-danger" type="button" @click="$emit('close')">Close</button>
            </p>
        </div>
    </div>
</template>

<script setup>
import BaseIcon from "../ui/BaseIcon";
import IconViewportWide from "../icons/IconViewportWide";</script>

<style scoped>
.design-tool-width-modal {
    position: fixed; /* Stay in place */
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.design-tool-width-modal-content {
    background-color: #ffffff;
    margin: 40px auto 20px auto;
    padding: 40px 30px 20px 30px;
    width: 80%;
}
</style>
